// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"_4-z"};